import React from "react";
import Fade from "react-reveal/Fade";
// Comps
// Css
import classes from "./Content.module.scss";

const Content: React.FC = () => {
  return (
    <>
      <Fade top>
        <h2 className={classes.title}>tips and tricks</h2>
      </Fade>
      <p className={classes.desc}>
        If you are a Liberal, always tell the truth. Remember that Fascists
        (except for Hitler) know each other and creating confusion will only
        confuse other Liberals. As the President, always give the Chancellor
        both Liberal and Fascist policies whenever possible, and as Chancellor,
        always enact Liberal policies. Never, ever say you are the Fascist as it
        will only harm your team. If you are Fascist, create confusion. Keep
        pretending to be a Liberal and only enact Fascist policies when you can
        make it seem like you have no other choice. As the President, pretend
        that you had no choice but to give the Chancellor both Fascist policies,
        and as Chancellor, pretend that you only had Fascist policies to enact.
        Additionally, help Hitler gain the trust from the Liberals by allowing
        them to enact Liberal policies and do not accuse them of being a
        Fascist. If you are Hitler, pretend to be a Liberal. Enact Liberal
        policies and rely on your fellow Fascists to enact Fascist policies. As
        President, you may occasionally pretend to have gotten all Fascist
        policies and had no choice but to give the Chancellor only Fascist
        policies. However, do not overdo this!
      </p>
    </>
  );
};

export default Content;
